import { LOANREQUEST_STATUSES, SUB_STATUS_OFFER_AT_BANK } from 'cpool-constants';
import { z } from 'zod';

import { commonSchema } from '../common';

export const schemaOfferAtBank = z
    .object({
        status: z.literal(LOANREQUEST_STATUSES.OFFER_AT_BANK),
        subStatus: z.nativeEnum(SUB_STATUS_OFFER_AT_BANK).optional(),
    })
    .merge(commonSchema);
